import { render, staticRenderFns } from "./Heidiland.vue?vue&type=template&id=6f8641e6&"
import script from "./Heidiland.vue?vue&type=script&lang=js&"
export * from "./Heidiland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports